import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import CarousselService from '../../services/carousselService';

const initialState = {
  Caroussel: [],
  CarousselId: {},
  pageSize: 20,
  currentPage: 1,
  totalElements: 0,
  isError: false,
  isSuccess: false,
  isLoading: false,
  message: '',
};

export const createCarousselSlice = createAsyncThunk(
  'carroussel/create',
  async (data, thunkAPI) => {
    try {
      return await CarousselService.createCaroussel(data);
    } catch (error) {
      const message =
        (error.response && error.response.data && error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const getAllCaroussel = createAsyncThunk(
  'carroussel/getAll',
  async (_, thunkAPI) => {
    try {
      return await CarousselService.getAll();
    } catch (error) {
      const message =
        (error.response && error.response.data && error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const deleteCaroussel = createAsyncThunk(
  'carroussel/delete',
  async (id, thunkAPI) => {
    try {
      return await CarousselService.DeleteCaroussel(id);
    } catch (error) {
      const message =
        (error.response && error.response.data && error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const reoderCaroussel = createAsyncThunk(
  'carroussel/reoder',
  async (data, thunkAPI) => {
    try {
      return await CarousselService.reoderCaroussel(data);
    } catch (error) {
      const message =
        (error.response && error.response.data && error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const CarousselSlice = createSlice({
  name: 'caroussel',
  initialState,
  reducers: {
    clearCaroussel: state => initialState,
  },
  extraReducers: builder => {
    builder
      .addCase(createCarousselSlice.pending, state => {
        state.isLoading = true;
      })
      .addCase(createCarousselSlice.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        const created = action.payload?.result || action.payload?.data || action.payload;
        if (created) state.Caroussel.unshift(created);
      })
      .addCase(createCarousselSlice.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      })
      .addCase(getAllCaroussel.pending, state => {
        state.isLoading = true;
      })
      .addCase(getAllCaroussel.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        const payload = action.payload?.result || action.payload?.data || action.payload;
        const items = Array.isArray(payload) ? payload : payload?.items || payload?.data || [];
        state.Caroussel = items;
        const pagination = action.payload?.pagination || {};
        state.currentPage = pagination.current_page || 1;
        state.pageSize = pagination.limit || items.length || 20;
        state.totalElements = pagination.total_items || items.length || 0;
      })
      .addCase(getAllCaroussel.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      })
      .addCase(deleteCaroussel.pending, state => {
        state.isLoading = true;
      })
      .addCase(deleteCaroussel.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        const deletedId = action.payload?.data;
        state.Caroussel = state.Caroussel.filter(item => item.id !== deletedId);
      })
      .addCase(deleteCaroussel.rejected, (state, action) => {
        state.isLoading = false;
        state.message = action.payload;
      })
      .addCase(reoderCaroussel.pending, state => {
        state.isLoading = true;
      })
      .addCase(reoderCaroussel.fulfilled, (state, action) => {
        state.isLoading = false;
      })
      .addCase(reoderCaroussel.rejected, (state, action) => {
        state.isLoading = false;
        state.message = action.payload;
      });
  },
});

export const { clearCaroussel } = CarousselSlice.actions;
export default CarousselSlice.reducer;
